import { useFeatureFlag } from '@application/feature_flags/use_feature_flag';
import { BreakPoints, DialogModal, Sheet, useBreakpoint } from '@cellula/react';
import { Slot } from '@radix-ui/react-slot';
import { useResolveController } from '@visiba/instantiation';
import { AuthMethods } from './_auth_methods.component';
import { AuthController } from './auth.controller';

export function AuthSignInSheet({ returnUrl, trigger, onClose, onOpen }: Props) {
	const authController = useResolveController(AuthController);
	const useIDP = useFeatureFlag('CareExperience.PW.Idp');
	const breakpoint = useBreakpoint();

	if (!useIDP) {
		function handleTriggerClick() {
			onOpen?.();
			window.dispatchEvent(
				new CustomEvent('triggerSignIn', {
					detail: { target: authController.getReturnUrl(returnUrl), openTargetWith: 'NativeNavigation', leave: false },
				}),
			);
		}

		return <Slot onClick={handleTriggerClick}>{trigger}</Slot>;
	}

	if (breakpoint >= BreakPoints.Medium) {
		function handleOpenChange(open: boolean) {
			if (open) {
				onOpen?.();
			} else {
				onClose?.();
			}
		}

		return (
			<DialogModal.Root trigger={trigger} onOpenChange={handleOpenChange}>
				<DialogModal.Content>
					<AuthMethods returnUrl={returnUrl} asDialogContent />
				</DialogModal.Content>
			</DialogModal.Root>
		);
	}

	return (
		<Sheet
			label='' // We don't want any label. We will use a H1 in the AuthMethods component instead.
			onClose={onClose}
			onOpen={onOpen}
			trigger={trigger}
		>
			<AuthMethods returnUrl={returnUrl} asDialogContent />
		</Sheet>
	);
}

interface Props {
	returnUrl: string;
	trigger: JSX.Element;
	onClose?: () => void;
	onOpen?: () => void;
}
